import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  sectionHeading: {
    color: '#264e98',
    fontSize: '1.8rem',
    letterSpacing: '-0.025em',
    fontWeight: 800,
    fontFamily: 'Verdana'
  },
  subHeading: {
    color: '#264e98',
    fontSize: '1.2rem',
    letterSpacing: '-0.025em',
    fontWeight: 800,
    fontFamily: 'Verdana',
    textAlign: 'left',
    margin: theme.spacing(1)
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  card: {
    marginBottom: theme.spacing(2),
    '&:hover': {
      boxShadow: theme.shadows[8],
    },
  },
  cardContent: {
    paddingBottom: theme.spacing(2),
  },

  field: {
    marginBottom: theme.spacing(1.5),
  },
  label: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  value: {
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
  tableHeading: {
    textTransform: 'uppercase',
    color: '#747782'
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },

  gridTable_rowHeading: {
    borderBottom: '1px solid grey',
    padding: theme.spacing(1.5),
  },
  gridTable_rowNoBorder: {
    alignItems: 'center',
    padding: theme.spacing(1.5),
  },
  gridTable_row: {
    alignItems: 'center',
    padding: theme.spacing(1.5),
    borderBottom: '1px solid grey',
  },
  gridTable_fieldAlignLeft: {
    textAlign: 'left'
  },
  gridTable_fieldAlignCenter: {
    textAlign: 'center'
  },
  gridTable_fieldAlignRight: {
    textAlign: 'right'
  },
  gridTable_labelField: {
    paddingTop: theme.spacing(1.5),
    textTransform: 'uppercase',
    color: '#747782'
  },
  gridTable_noRecords: {
    padding: theme.spacing(1.5),
    alignItems: 'center'
  },

  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },

  success: {
    backgroundColor: '#dcfce7',
    color: '#15803d'
  },
  warning: {
    backgroundColor: '#fef9c3',
    color: '#a16207'  
  },
  danger: {
    backgroundColor: '#ffdad5',
    color: '#bc0007'
  }
}));

export default function useErmaStyling() {
  const theme = useTheme();
  const ermaStyles = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return { 
    isMobile: isMobile, 
    ermaStyles: ermaStyles
  };
}